export let TypeNames = /*#__PURE__*/function (TypeNames) {
  TypeNames["USER"] = "_custom_User";
  TypeNames["USER_INPUT"] = "_custom_UserInput";
  TypeNames["USER_MANAGE_CONFIG"] = "_custom_UserManageConfig";
  TypeNames["USER_DETAILS_MUTABILITY_CONSTRAINTS"] = "_custom_UserDetailsMutabilityConstraints";
  TypeNames["USER_MANAGE_LINKED_ACCOUNTS"] = "_custom_UserManageLinkedAccounts";
  TypeNames["PRIVACY_VALUE"] = "_custom_PrivacyValue";
  TypeNames["PRIVACY_VALUE_INPUT"] = "_custom_PrivacyValueInput";
  TypeNames["PRIVACY_SETTINGS"] = "_custom_PrivacySettings";
  TypeNames["PRIVACY_SETTINGS_INPUT"] = "_custom_PrivacySettingsInput";
  TypeNames["PRIVACY_VALUES_CONFIG"] = "_custom_PrivacyValuesConfig";
  TypeNames["USER_PLACE"] = "_custom_UserPlace";
  TypeNames["USER_ORGANIZATION"] = "_custom_UserOrganization";
  TypeNames["PERMISSION_VALUE"] = "_custom_PermissionValue";
  TypeNames["AVATAR"] = "_custom_Avatar";
  TypeNames["MY_AVATAR"] = "_custom_MyAvatar";
  TypeNames["TeamSlackStatus"] = "_custom_TeamSlackStatus";
  TypeNames["CLASSIC_APP"] = "_custom_ClassicApp";
  TypeNames["CLASSIC_APPS"] = "_custom_ClassicApps";
  TypeNames["MARKETPLACE_APP"] = "_custom_MarketplaceApp";
  TypeNames["CLASSIC_APP_INSTALLATION"] = "_custom_ClassicAppInstallation";
  TypeNames["MARKETPLACE_APP_PERMISSION"] = "_custom_MarketplaceAppPermission";
  TypeNames["MARKETPLACE_APP_PERMISSIONS"] = "_custom_MarketplaceAppPermissions";
  TypeNames["API_TOKEN"] = "_custom_ApiToken";
  TypeNames["SESSIONS_AND_DEVICES"] = "_custom_SessionsAndDevices";
  TypeNames["SESSION"] = "_custom_Session";
  TypeNames["DEVICE"] = "_custom_Device";
  TypeNames["ELEVATED_SESSION"] = "_custom_ElevatedSession";
  TypeNames["TSV_ENROLLMENT_DETAILS"] = "_custom_TsvEnrollmentDetails";
  TypeNames["CONTAINERS"] = "_custom_Containers";
  TypeNames["CONTAINER"] = "_custom_Container";
  TypeNames["CONTAINER_DETAILS"] = "_custom_ContainerDetails";
  TypeNames["COLOUR_SETTING"] = "_custom_ColourSetting";
  TypeNames["TEAM_LINK_ICON"] = "_custom_TeamLinkIcon";
  return TypeNames;
}({});